<template>
  <div>
    <card class="card" title="Your Profile">
      <div>
        <div class="card">
          <ul class="list-group list-group-flush">
            <li class="list-group-item my-2">Name: {{ user.name }}</li>
            <li class="list-group-item my-2">
              Company Name: {{ user.companyName }}
            </li>
            <li class="list-group-item my-2">Wallet Id: {{ user.walletId }}</li>
            <li class="list-group-item my-2">
              Balance: {{ `₦${format.format(user.walletBalance.toFixed(2))}` }}
            </li>
          </ul>
        </div>

        <div
          class="spinner-grow"
          role="status"
          v-if="loading.show === true"
        ></div>

        <h4>Transfer Funds</h4>
        <form @submit.prevent>
          <div class="row">
            <div class="col-md-4">
              <label for="inlineFormInput">Select a Bank </label>
              <select
                class="form-control"
                v-model="bank"
                :disabled="transferStage !== 1"
              >
                <option v-for="b in user.bankList" :key="b.bankCode" :value="b">
                  {{ b.bankName }}
                </option>
              </select>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Amount"
                placeholder="Amount"
                v-model="transfer.amount"
                :disabled="transferStage !== 1"
              >
              </fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Account Number"
                placeholder="Account Number"
                v-model="transfer.accountNo"
                :disabled="transferStage !== 1"
              >
              </fg-input>
            </div>
          </div>

          <div v-if="transferStage === 2" class="row">
            <div class="col-md-6">
              <li class="list-group-item my-2">
                Account Name: {{ transfer.name }}
              </li>
            </div>
            <div class="col-md-6">
              <li class="list-group-item my-2">Bvn: {{ transfer.bvn }}</li>
            </div>
          </div>

          <div class="row">
            <div class="col-md-6">
              <fg-input
                type="text"
                label="Narration"
                placeholder="Narration"
                v-model="transfer.narration"
                :disabled="transferStage === 1"
              >
              </fg-input>
            </div>
            <div class="col-md-6">
              <fg-input
                type="password"
                label="Enter Password"
                placeholder="************"
                v-model="transfer.password"
                :disabled="transferStage === 1"
              >
              </fg-input>
            </div>
          </div>

          <div class="text-center">
            <p-button
              v-if="transferStage === 1"
              type="info"
              round
              @click.native.prevent="submitValidation"
            >
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Validate
            </p-button>
            <p-button
              v-else
              type="info"
              round
              @click.native.prevent="submitPayment"
            >
              <div
                class="spinner-grow"
                role="status"
                v-if="loading.show === true"
              ></div>
              Make Payment
            </p-button>
          </div>
          <div class="clearfix"></div>
        </form>
      </div>
    </card>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import axios from "../store/axios";
import router from "../router";
export default {
  data() {
    return {
      user: {
        name: "",
        firstName: "",
        lastName: "",
        email: "",
        phoneNumber: "",
        companyName: "",
        userType: "",
        walletBalance: 0,
        bankList: [],
      },
      transfer: {},
      transferStage: 1,
      bank: {},
      format: new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),
    };
  },
  computed: {
    ...mapState(["auth", "loading", "utils"]),
  },
  methods: {
    ...mapActions([
      "adminChangeUserPassword",
      "setNotification",
      "enableUser",
      "disableUser",
      "setLoading",
    ]),
    submitValidation() {
      this.$confirm("Validate?").then(async () => {
        this.setLoading(true);
        try {
          const res = await axios.post(
            `${process.env.VUE_APP_API_URL}/admin/transaction/transfer/validation`,
            { ...this.transfer, ...this.bank },
          );
          const { responseCode, message, errors, data } = res.data;
          if (responseCode === "00") {
            this.setNotification({
              type: "success",
              message,
            });
            this.transferStage = 2;
            this.transfer = {
              ...this.transfer,
              sessionId: data.account.id,
              bvn: data.bvn,
              name: data.name,
              channel: "web",
              uniqueId: this.generateUniqueId(data.account.id),
            };
          } else {
            if (errors) {
              Object.values(errors).forEach((element) => {
                this.setNotification({
                  type: "danger",
                  message: JSON.stringify(element),
                });
              });
            } else {
              this.setNotification({
                type: "danger",
                message,
              });
            }
          }
        } catch (err) {
          console.log(err);
          const { message } = err.response.data;
          this.setNotification({
            type: "danger",
            message: message || "Unable to Validate",
          });
        }
        this.setLoading(false);
      });
    },
    submitPayment() {
      this.$confirm("Transfer Funds?").then(async () => {
        this.setLoading(true);
        try {
          const res = await axios.post(
            `${process.env.VUE_APP_API_URL}/admin/transaction/transfer/payment`,
            this.transfer,
          );
          const { responseCode, message, errors } = res.data;
          if (responseCode === "00") {
            this.setNotification({
              type: "success",
              message,
            });
            setTimeout(function () {
              router.push("/dashboard/vas-transactions");
            }, 5000);
          } else {
            if (errors) {
              Object.values(errors).forEach((element) => {
                this.setNotification({
                  type: "danger",
                  message: JSON.stringify(element),
                });
              });
            } else {
              this.setNotification({
                type: "danger",
                message,
              });
            }

            this.setLoading(false);
          }
        } catch (err) {
          console.log(err);
          const { message } = err.response.data;
          this.setNotification({
            type: "danger",
            message: message || "Unable to Process Payment",
          });

          this.setLoading(false);
        }
      });
    },
    generateUniqueId(id) {
      let result = "";
      const characters =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      const charactersLength = characters.length;
      for (var i = 0; i < 7; i++) {
        result += characters.charAt(
          Math.floor(Math.random() * charactersLength),
        );
      }
      return `${result}${id}`;
    },
    async getUser() {
      this.setLoading(true);
      try {
        const res = await axios.post(
          `${process.env.VUE_APP_API_URL}/admin/details/fetch`,
        );
        const { data } = res.data;
        this.user = data;
      } catch (err) {
        const { data } = err.response.data;
        console.log(data);
        if (data) {
          this.setNotification({
            type: "danger",
            message: data.message || "Unable to Fetch User Data",
          });
        }
      }
      this.setLoading(false);
    },
  },
  async mounted() {
    await this.getUser();
  },
};
</script>
<style>
.spinner-grow {
  position: fixed;
}
</style>
